
import React from "react";
import { Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FormItem, FormLabel } from "@/components/ui/form";

interface LogoUploadProps {
  logoPreview: string | null;
  onLogoChange: (file: File | undefined) => void;
}

const LogoUpload = ({ logoPreview, onLogoChange }: LogoUploadProps) => {
  const handleLogoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      onLogoChange(file);
    }
  };

  const handleRemoveLogo = () => {
    onLogoChange(undefined);
  };

  return (
    <FormItem>
      <FormLabel className="flex items-center gap-2">
        <Upload className="w-4 h-4" />
        Company Logo
      </FormLabel>
      <div className="mt-2">
        <div className="flex items-center gap-4">
          <label className="cursor-pointer">
            <div className="flex items-center justify-center w-40 h-40 border-2 border-dashed border-gray-300 rounded-lg hover:border-redflags-red transition-colors">
              {logoPreview ? (
                <img 
                  src={logoPreview} 
                  alt="Logo preview" 
                  className="w-full h-full object-contain rounded-lg"
                />
              ) : (
                <div className="flex flex-col items-center text-gray-400">
                  <Upload className="w-8 h-8 mb-2" />
                  <span className="text-sm text-center">Upload logo</span>
                </div>
              )}
            </div>
            <input
              type="file"
              accept="image/*"
              className="hidden"
              onChange={handleLogoChange}
            />
          </label>
          
          {logoPreview && (
            <Button
              type="button"
              variant="outline"
              className="text-redflags-red"
              onClick={handleRemoveLogo}
            >
              Remove
            </Button>
          )}
        </div>
        <p className="text-sm text-gray-500 mt-2">
          Recommended: Square image, at least 200x200px
        </p>
      </div>
    </FormItem>
  );
};

export default LogoUpload;
